define(['exports', 'react', 'lodash', 'classnames', '../../i18n', '../../assets/slow.svg', '../../assets/fast.svg', '../common/ToolTipComponent', './styles/CandidateReportsView.css'], function (exports, _react, _lodash, _classnames, _i18n, _slow, _fast, _ToolTipComponent) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _lodash2 = _interopRequireDefault(_lodash);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _i18n2 = _interopRequireDefault(_i18n);

  var _slow2 = _interopRequireDefault(_slow);

  var _fast2 = _interopRequireDefault(_fast);

  var _ToolTipComponent2 = _interopRequireDefault(_ToolTipComponent);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var ReportSectionsWrapperInfo = function (_Component) {
    _inherits(ReportSectionsWrapperInfo, _Component);

    function ReportSectionsWrapperInfo() {
      _classCallCheck(this, ReportSectionsWrapperInfo);

      return _possibleConstructorReturn(this, (ReportSectionsWrapperInfo.__proto__ || Object.getPrototypeOf(ReportSectionsWrapperInfo)).apply(this, arguments));
    }

    _createClass(ReportSectionsWrapperInfo, [{
      key: 'renderProblemName',
      value: function renderProblemName(name, toolTipLabel, toolTipMessage, id) {
        return _react2.default.createElement(
          'div',
          { className: 'mt3 flex', style: { color: '#000', fontSize: '1rem', fontWeight: 500 } },
          _react2.default.createElement(
            'div',
            { className: '' },
            name
          ),
          _react2.default.createElement(
            'div',
            {
              className: (0, _classnames2.default)('field-name-primary', { 'display-none': !toolTipLabel || !toolTipMessage }) },
            _react2.default.createElement(_ToolTipComponent2.default, {
              className: 'clearfix ml2',
              toolTipId: id + ' ' + name + ' ' + toolTipLabel,
              label: toolTipLabel,
              message: toolTipMessage })
          )
        );
      }
    }, {
      key: 'renderSpeedDetail',
      value: function renderSpeedDetail(speed, recommendedSpeed) {
        return _react2.default.createElement(
          'div',
          { className: 'flex justify-between field-name-primary', style: { color: '#9E9E9E' } },
          _react2.default.createElement(
            'div',
            { className: 'col-4' },
            _react2.default.createElement(
              'div',
              { className: (0, _classnames2.default)('', { 'display-none': _lodash2.default.isNumber(speed) }) },
              '- N/A'
            ),
            _react2.default.createElement(
              'div',
              { className: (0, _classnames2.default)('black', { 'display-none': !_lodash2.default.isNumber(speed) }) },
              _react2.default.createElement(
                'span',
                { className: 'relative', style: { bottom: '0.45rem' } },
                speed > 0 ? _react2.default.createElement(_fast2.default, null) : _react2.default.createElement(_slow2.default, null)
              ),
              _react2.default.createElement(
                'span',
                null,
                ' ',
                speed
              ),
              _react2.default.createElement(
                'span',
                null,
                ' ',
                _i18n2.default.t('dk-ui-lib.reports.mins')
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-8 center' },
            _react2.default.createElement(
              'span',
              null,
              _i18n2.default.t('dk-ui-lib.reports.recommended'),
              ' - '
            ),
            _react2.default.createElement(
              'span',
              null,
              recommendedSpeed ? recommendedSpeed + ' ' + _i18n2.default.t('dk-ui-lib.reports.mins') : 'N/A'
            )
          )
        );
      }
    }]);

    return ReportSectionsWrapperInfo;
  }(_react.Component);

  exports.default = ReportSectionsWrapperInfo;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/dk-ui-lib/lib/candidate-reports/ReportSectionsWrapperInfo.js
// module id = 466
// module chunks = 0